import { grey, blue } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import React, { useCallback, useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { Delete } from "@material-ui/icons";
import ListItemText from "@material-ui/core/ListItemText";
import { useTranslate } from "react-polyglot";
import Tooltip from "@material-ui/core/Tooltip";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import useDateUtils from "../../../../hooks/useDateUtils.js";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";
import { replaceUrlsWithLinks } from "../../../../Utils/misc";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 10,
  },
  date: {
    color: grey[700],
    margin: "0 5px",
  },
  messageWrap: {
    backgroundColor: ({ direction }) => (direction === "incoming" ? "#F3F2F2" : blue[700]),
    color: ({ direction }) => (direction === "incoming" ? "inherit" : "white"),
    padding: "5px 10px",
    borderRadius: 8,
    margin: ({ direction }) => (direction === "incoming" ? "0 50px 0 0" : "0 0 0 50px"),
    display: "flex",
    flexDirection: "column",
    alignItems: ({ direction }) => (direction === "incoming" ? "flex-start" : "flex-end"),
  },
  outgoing: {
    alignSelf: "end",
  },
  incoming: {
    alignSelf: "start",
  },
  readCheck: {
    fontSize: 15,
  },
  textStyle: {
    whiteSpace: "pre-wrap",
    "& a": {
      color: ({ direction }) => (direction === "outgoing" ? "wheat" : blue[800]),
      fontStyle: "italic",
    },
  },
}));

/**
 * @param {MessageData} data
 * @returns {*}
 * @constructor
 */
const MessagingBoxBodyItem = ({ data }) => {
  const classes = useStyles(data);
  const t = useTranslate();
  const { formatSmartDate } = useDateUtils();
  const { deleteMessage } = useChat();
  const [menuPosition, setMenuPosition] = useState(null);

  const direction = data.direction;

  const handleContextMenu = useCallback(
    (e) => {
      if (menuPosition || direction === "incoming") return;

      e.preventDefault();
      setMenuPosition({
        mouseX: e.clientX + 2,
        mouseY: e.clientY + 2,
      });
    },
    [menuPosition, direction],
  );

  /** */
  const handleCloseMenu = () => setMenuPosition(null);

  return (
    <Box
      onContextMenu={handleContextMenu}
      className={clsx(classes.root, classes[direction])}
      display="flex"
      flexDirection="column"
    >
      <Box className={classes.messageWrap}>
        <Typography
          className={classes.textStyle}
          dangerouslySetInnerHTML={{ __html: replaceUrlsWithLinks(data.text) }}
        />
        {data.read && data.direction === "outgoing" && (
          <Tooltip title={t("chat.read")}>
            <CheckRoundedIcon className={classes.readCheck} />
          </Tooltip>
        )}
      </Box>
      <Typography className={clsx(classes.date, classes[direction])} variant="body2">
        {formatSmartDate(new Date(data.date))}
      </Typography>
      <Menu
        open={Boolean(menuPosition)}
        onClose={handleCloseMenu}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition !== null ? { top: menuPosition.mouseY, left: menuPosition.mouseX } : undefined}
      >
        <MenuItem
          onClick={() => {
            deleteMessage(data.id);
            handleCloseMenu();
          }}
        >
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={t("chat.delete")} />
        </MenuItem>
      </Menu>
    </Box>
  );
};

MessagingBoxBodyItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default MessagingBoxBodyItem;
